import * as React from "react";
import { useContext, useEffect } from "react";
import { Field, useFormikContext } from "formik";
import moment from "moment";
import { HelpBlock, Row } from "components/bootstrap";
import TimeRangeFilter from "views/components/searchbar/time-range-filter";
import ExportSettingsContext from "views/components/ExportSettingsContext";
import { adjustFormat, toUTCFromTz } from "util/DateTime";
import useUserDateTime from "hooks/useUserDateTime";
import TimeRangeInputSettingsContext from "views/components/contexts/TimeRangeInputSettingsContext";
import useSearchConfiguration from "hooks/useSearchConfiguration";
const timeRangeContext = {
  showDropdownButton: true,
  showPresetsButton: true,
  showAddToQuickListButton: false
};
const toPickerRange = (timerange, toUserTime) => timerange ? {
  type: "absolute",
  from: toUserTime(timerange.from, "complete"),
  to: toUserTime(timerange.to, "complete")
} : void 0;
const fromPickerRange = (timerange, userTimezone) => timerange ? {
  type: "absolute",
  from: adjustFormat(toUTCFromTz(timerange.from, userTimezone), "internal"),
  to: adjustFormat(toUTCFromTz(timerange.to, userTimezone), "internal")
} : null;
const LogViewExportSettings = () => {
  var _a;
  const { settings } = useContext(ExportSettingsContext);
  const { formatTime, userTimezone } = useUserDateTime();
  const { config: searchesClusterConfig } = useSearchConfiguration();
  const { setFieldValue } = useFormikContext();
  const limitDuration = (_a = moment.duration(searchesClusterConfig == null ? void 0 : searchesClusterConfig.query_time_range_limit).asSeconds()) != null ? _a : 0;
  useEffect(() => {
    setFieldValue("customSettings.timerange", settings == null ? void 0 : settings.timerange);
  }, [setFieldValue, settings]);
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Field, { name: "customSettings.timerange" }, ({ field: { name, value, onChange } }) => {
    const currentTimeRange = toPickerRange(value, formatTime);
    const setCurrentTimeRange = (newTimeRange) => onChange({ target: { name, value: fromPickerRange(newTimeRange, userTimezone) } });
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { htmlFor: name }, "Time Range"), /* @__PURE__ */ React.createElement(TimeRangeInputSettingsContext.Provider, { value: timeRangeContext }, /* @__PURE__ */ React.createElement(
      TimeRangeFilter,
      {
        value: currentTimeRange,
        onChange: setCurrentTimeRange,
        validTypes: ["absolute"],
        showPresetDropdown: false,
        limitDuration
      }
    )), /* @__PURE__ */ React.createElement(HelpBlock, null, "This is the time range which is used for the export. It defaults to the range you are currently seeing in the widget. If you want it to include more/less messages, you can adjust by clicking on the button/summary."));
  }));
};
export default LogViewExportSettings;
